<div
  class="icon-button-container mat-typography"
  [ngClass]="{
    vertical: vertical,
    'is-active-button': active,
    'is-disabled-button': !(isEnabled() | async)
  }"
>
  <button
    class="icon-button"
    mat-icon-button
    [ngClass]="{
      'mat-primary': color === 'primary',
      'mat-accent': color === 'accent'
    }"
    [type]="getType()"
    (click)="onClick($event)"
    [disabled]="!(isEnabled() | async)"
  >
    <mat-icon *ngIf="displayIcon" [svgIcon]="getIcon()"></mat-icon>
  </button>
  <span
    class="icon-button-span mat-caption"
    *ngIf="(isShowTitle | async) && displayTitle"
    [ngClass]="{
      'mat-primary': color === 'primary',
      disabled: !(isEnabled() | async)
    }"
    >{{ getTitle() }}</span
  >
</div>
